<template>
  <form>
    <div class="input-group two-children">
      <input
        type="text"
        v-model="project.name"
        placeholder="Project Name"
      />
      <input
        type="text"
        v-model="project.colour"
        placeholder="Hex Colour"
      />
    </div>

    <div class="input-group two-children">
      <ToggleSwitch
        :checked.sync="project.isActive"
        :title="'Active Project'"
      />
      <ToggleSwitch
        :checked.sync="project.showBrokeUsers"
        :title="'Show Broke Users'"
      />
    </div>

    <ProjectFilters :project="project" />

    <ProjectFilterForm
      v-if="showAddFilterForm"
      :filter="newFilter"
      @delete-filter="initAddFilterForm"
    />

    <div class="add-filter-button-container">
      <Button
        :title="'+ Add Filter'"
        :type="'outlined'"
        :colorTheme="'secondary'"
        @button-click="displayAddFilterForm"
      />
    </div>

    <div class="button-group primary-button-group">
      <div class="desktop-delete-button">
        <Button
          :title="'Delete All Users'"
          :type="'flat'"
          :colorTheme="'warning'"
          @button-click="$emit('delete-all-users')"
        />
      </div>
      <div class="action-buttons">
        <Button
          :title="'Save'"
          :type="'raised'"
          :colorTheme="'primary'"
          @button-click="saveProject"
        />
        <Button
          :title="'Cancel'"
          :type="'raised'"
          :colorTheme="'secondary'"
          @button-click="cancelForm"
        />
      </div>
    </div>

    <div class="button-group secondary-button-group" v-if="selectedProject">
      <Button
        :title="'Delete All Users'"
        :type="'flat'"
        :colorTheme="'warning'"
        @button-click="$emit('delete-all-users')"
      />
    </div>
  </form>
</template>

<script>
import ToggleSwitch from '@/components/form-elements/ToggleSwitch.vue'
import Button from '@/components/form-elements/Button';
import ProjectFilters from '@/components/project/ProjectFilters';
import ProjectFilterForm from '@/components/project/ProjectFilterForm';

export default {
  name: 'ProjectForm',
  props: ['selectedProject'],
  components: {
    ProjectFilters,
    ProjectFilterForm,
    Button,
    ToggleSwitch
  },
  data() {
    if (this.selectedProject) {
      return {
        project: this.selectedProject,
        showAddFilterForm: false
      }
    } else {
      return {
        project: {
          name: '',
          colour: '',
          filters: [],
          isActive: true,
          showBrokeUsers: true
        },
        showAddFilterForm: false
      }
    }
  },
  created() {
    if (this.selectedProject) this.projectBeforeEdit = JSON.parse(JSON.stringify(this.selectedProject))
    this.newFilter = this.initFilter()
  },
  methods: {
    saveProject() {
      if (!this.project.filters) {
        this.project.filters = []
      }
      if (this.hasNewFilterBeenFilledOut()) {
        this.project.filters.push(this.newFilter)
      }
      this.project.filters = this.cleanedUpProjectFilters();
      this.$emit('save-project', this.project)
      this.initAddFilterForm()
    },
    cancelForm() {
      Object.assign(this.project, this.projectBeforeEdit)
      this.$emit('hide-dialog')
    },
    displayAddFilterForm() {
      this.showAddFilterForm = true
    },
    initAddFilterForm() {
      this.showAddFilterForm = false
      this.newFilter = this.initFilter()
    },
    initFilter() {
      return { name: '', values: [] }
    },
    hasNewFilterBeenFilledOut() {
      return this.newFilter.name !== '' && this.newFilter.values !== []
    },
    cleanedUpProjectFilters() {
      let filtersClone = this.project.filters.slice(0)
      filtersClone.forEach((filter) => {
        if (typeof filter.values === 'string') {
          filter.values = this.convertStringToArray(filter.values)
        }
      })
      return filtersClone
    },
    convertStringToArray(values) {
      return values.replace(/(^,)|(,$)/g, "").trim().split(',').map((value) => value.trim())
    }
  }
}
</script>

<style scoped lang="scss" rel="stylesheet/scss">
@import '../../assets/styles/colors';
@import '../../assets/styles/mixin';
@import '../../assets/styles/input';
@import '../../assets/styles/dialog';
@import '../../assets/styles/card';
@import '../../assets/styles/switch';

.add-filter-button-container {
  padding-bottom: 16px;
  border-bottom: 1px solid $primary-shadow;

  button {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/project/ProjectForm.vue